import { Component, numberAttribute } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { Dotcom2024Service } from '../dotcom2024.service';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MyharrellsService } from '../myharrells.service';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.css'
})
export class AboutComponent {

  coreValuesURL: any;

  constructor(public myHarrellsService: MyharrellsService, private _sanitizer: DomSanitizer, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service) {
    this.coreValuesURL = this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/pHhDsiz5M5U");

  }

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/About/";

  visableSection: number = 0;


  firstNameRepMatch: string = "";
  lastNameRepMatch: string = "";
  emailRepMatch: string = "";
  phoneRepMatch: string = "";
  companyRepMatch: string = "";
  titleRepMatch: string = "";
  cityRepMatch: string = "";
  stateRepMatch: string = "";
  zipRepMatch: string = "";
  marketsRepMatch: string = "";
  commentsRepMatch: string = "";
  golfRepMatch: boolean = false;
  lawnCareRepMatch: boolean = false;
  horticultureRepMatch: boolean = false;
  sportsTurfRepMatch: boolean = false;
  specialtyAgRepMatch: boolean = false;


  ngOnInit(): void {

    this.dotComService.activePage = "about"

    //meta tags for SEO
    this.title.setTitle("About Harrell’s | 100% Employee-Owned Agronomic Experts");
    this.meta.updateTag({ name: 'description', content: "Harrell’s is a 100% employee-owned leader in agronomic solutions, supplying professionals nationwide with premium fertilizers, pesticides, and support." });
    this.meta.updateTag({ property: 'og:title', content: "About Harrell’s | 100% Employee-Owned Agronomic Experts" });
    this.meta.updateTag({ property: 'og:description', content: "Harrell’s is a 100% employee-owned leader in agronomic solutions, supplying professionals nationwide with premium fertilizers, pesticides, and support." });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - about" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - about" });
    this.meta.updateTag({ property: 'Twitter:card', content: "About Harrell’s | 100% Employee-Owned Agronomic Experts" });
    this.meta.updateTag({ property: 'Twitter:site', content: "About Harrell’s | 100% Employee-Owned Agronomic Experts" });
    this.meta.updateTag({ property: 'Twitter:title', content: "About Harrell’s | 100% Employee-Owned Agronomic Experts" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Harrell’s is a 100% employee-owned leader in agronomic solutions, supplying professionals nationwide with premium fertilizers, pesticides, and support." });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - about" });





  }

  ToggleExpand(sectionId: number) {
    if (this.visableSection == sectionId) {
      this.visableSection = 0;
    } else {
      this.visableSection = sectionId;

    }
  }

  OpenCoreValuesModal() {
    //height and width of modal must be 40px larger than video to get that border
    //tht is why the css for the modal is 840x540px when the video tag itself is 800x500
    document.getElementById("coreValuesModal").style.display = "block";
    (<HTMLVideoElement>document.getElementById('coreValuesVideo')).play();
  }

  CloseCoreValuesModal() {
    (<HTMLVideoElement>document.getElementById('coreValuesVideo')).pause();
    document.getElementById("coreValuesModal").style.display = "none";
  }

  OpenOurWhyModal() {
    //height and width of modal must be 40px larger than video to get that border
    //tht is why the css for the modal is 840x540px when the video tag itself is 800x500
    document.getElementById("ourWhyModal").style.display = "block";
    (<HTMLVideoElement>document.getElementById('ourWhyVideo')).play();
  }

  CloseOurWhyModal() {
    (<HTMLVideoElement>document.getElementById('ourWhyVideo')).pause();
    document.getElementById("ourWhyModal").style.display = "none";
  }

  OpenCelebrationModal() {
    //height and width of modal must be 40px larger than video to get that border
    //tht is why the css for the modal is 840x540px when the video tag itself is 800x500
    document.getElementById("celebrationModal").style.display = "block";
    (<HTMLVideoElement>document.getElementById('celebrationVideo')).play();
  }

  CloseCelebrationModal() {
    (<HTMLVideoElement>document.getElementById('celebrationVideo')).pause();
    document.getElementById("celebrationModal").style.display = "none";
  }

  sendEmail() {
    const recipient = 'contact@harrells.com';
    const subject = "Harrell's - I'm Ready To Become A Customer!";
    const body = "Hello, I'm Ready To Become A Customer. \n \n " +
      "First Name: " + this.firstNameRepMatch + " \n " +
      "Last Name: " + this.lastNameRepMatch + " \n " +
      "Company: " + this.companyRepMatch + " \n " +
      "Job Title: " + this.titleRepMatch + " \n \n " +
      "Email: " + this.emailRepMatch + " \n " +
      "Phone: " + this.phoneRepMatch + " \n " +
      "City: " + this.cityRepMatch + " \n " +
      "State: " + this.stateRepMatch + " \n " +
      "Zip: " + this.zipRepMatch + " \n " +
      "Golf: " + this.golfRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n " +
      "Horticulture: " + this.horticultureRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n " +
      "SportsTurf: " + this.sportsTurfRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n " +
      "SpecialtyAg: " + this.specialtyAgRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n " +
      "LawnCare: " + this.lawnCareRepMatch.toString().replace('false', '').replace('true', 'Yes') + " \n \n " +
      "Comments: " + this.commentsRepMatch + " \n "

    const mailtoUrl = `mailto:${recipient}?subject=${subject}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoUrl;

  }


}
